/**
 * Created by Sasha on 4/1/2019.
 */
import {
  Component , ElementRef , EventEmitter ,
  Input ,
  OnChanges , OnDestroy , OnInit , Output , ViewChild ,
} from '@angular/core';
import html2canvas from 'html2canvas';
import {NgxSpinnerService} from "ngx-spinner";

@Component({
    selector: 'simple-tree',
    templateUrl: './simple-tree.html',
    styleUrls: ['./simple-tree.scss'],
    standalone: false
})
export class SimpleTreeComponent implements OnChanges , OnDestroy , OnInit {
  @Input() data;
  @Input() type;
  @Input() color;
  @Input() systemTyp;
  @Input() isTime;
  @Input() name;
  @Output() time = new EventEmitter();
  checked = true;
  view: any[];
  colorScheme: any;
  animations: boolean = true;
  @ViewChild('screen') screen: ElementRef;
  @ViewChild('canvas') canvas: ElementRef;
  @ViewChild('downloadLink') downloadLink: ElementRef;
  showDownload = true;
  constructor (private spinner: NgxSpinnerService) {
  }

  ngOnInit () {
  }


  ngOnChanges () {
    if (this.color && this.color.domain.length) {
      this.colorScheme = this.color;
    }
  }


  ngOnDestroy () {

  }

  changeTime () {
    this.time.emit(this.isTime);
  }
  downloadImage(event){
    this.spinner.show();
    event.stopPropagation();
    html2canvas(this.screen.nativeElement).then(canvas => {
      this.canvas.nativeElement.src = canvas.toDataURL();
      this.downloadLink.nativeElement.href = canvas.toDataURL('image/png');
      this.downloadLink.nativeElement.download = 'marble-diagram.png';
      this.downloadLink.nativeElement.click();
      this.spinner.hide();
    });
  }
}
